function hidePreloader() {
  const preloader = document.getElementById('preloader-croma');
  if (preloader) {
    //alert("Nascondo preloader");
    preloader.style.opacity = '0';
    preloader.style.transition = 'opacity 0.3s ease';
    setTimeout(() => {
      preloader.style.display = 'none'; // invece di remove()
      document.body.classList.remove('preloader-active');
    }, 300);
  }
}

function forceHidePreloader() {
  const pageexit = document.getElementById('page-exit-overlay');
  //alert("forceHidePreloader") ;
  if (pageexit) {
    //  alert("trovato ") ;
    pageexit.classList.remove('active'); 
  }
}

document.body.classList.add('preloader-active');

window.addEventListener('load', function () {
  console.log("Evento: load");
  setTimeout(hidePreloader, 1000);
});

window.addEventListener('pageshow', function (event) {  
  if (event.persisted) {
    forceHidePreloader(); // eseguito al ritorno da cache
  }
});

window.addEventListener('unload', function () {
  
});

window.addEventListener('pagehide', function () {
  console.log("Evento: pagehide");
  forceHidePreloader();
});

// Exit overlay
document.addEventListener('DOMContentLoaded', function () {
  const overlay = document.getElementById('page-exit-overlay');

  document.querySelectorAll('a[href]:not([target="_blank"]):not([href^="#"])').forEach(link => {
    link.addEventListener('click', function (e) {
      const href = this.getAttribute('href');

      if (!href.startsWith('http') || href.includes(window.location.hostname)) {
        e.preventDefault();
        overlay.classList.add('active');
        const mainContent = document.getElementById('mainContent');
        mainContent.addEventListener('click', function (event) {
          const removeButton = event.target.closest('a[data-ajax-cart-request-button]');

          if (removeButton) {
            const cartItem = removeButton.closest('cart-item');

            if (cartItem) {
              
              const cartItem = removeButton.closest('cart-item')?.getAttribute('data-ondo-id');
                if(cartItem) {
                  const id = cartItem
                  if (id) {
                    let mainProductIdGet = document.querySelector('.cart-items')?.getAttribute('data-necklace-id');
                    mainProductIdGet = mainProductIdGet ? JSON.parse(mainProductIdGet) : [];
                    if (mainProductIdGet?.length && id && mainProductIdGet.includes(id)) {
                      localStorage.setItem('productId', 1);
                    }
                  }
                }
            }
          }
        });
        
        setTimeout(() => {
          const id = localStorage.getItem('productId');
           if (id != 1) {
             window.location.href = href;
           }
        }, 500);
      }
    });
  });
});
